// Example:
// {
//   id: 'example-feature',
//   name: 'Example',
//   checked: false,
//   description: 'Example description'
// }

// DO NOT REMOVE `as const`!
export const trunkFeatures = [
  {
    id: 'THY-2000-prevent-competitor-domains',
    name: 'THY-2000-prevent-competitor-domains',
    checked: false,
    description:
      'Reconnect notification settings form: block competitor email domains and migrate the "Contacting you" page to Reconnect',
  },
  {
    id: 'THY-2440-self-employment-reports',
    name: 'THY-2440-self-employment-reports',
    checked: false,
    description: 'Reports dashboard: monthly self-employment reports for the pilot salons',
  },
  {
    id: 'c-masqueraded',
    name: 'Masqueraded',
    checked: false,
    description: 'Simulate masqueraded session',
    isMasquerade: true,
  },
  {
    id: 'treatwell-pay-landing-page-enabled-by-country',
    name: 'Treatwell Pay landing page (by country)',
    checked: false,
  },
  {
    id: 'treatwell-pay-landing-page-enabled-by-venue',
    name: 'Treatwell Pay landing page (by venue)',
    checked: false,
  },
  {
    id: 'treatwell-pay-landing-page-requires-pos',
    name: 'Treatwell Pay landing page (requires POS)',
    checked: false,
    description: 'Markets on this flag (AT, DE) only see the page when POS is enabled',
  },
  {
    id: 'pos-de-tss',
    name: 'Pos DE TSS',
    checked: false,
    description: 'Tracking integration for POS DE TSS',
  },
  {
    id: 'CAR-1985-client-app-appvocacy-setting',
    name: 'CAR-1985-client-app-appvocacy-setting',
    checked: false,
  },
  {
    id: 'CAR-2635-client-forms-page',
    name: 'CAR-2635-client-forms-page',
    checked: false,
  },
  {
    id: 'webview-testing',
    name: 'webview-testing',
    checked: false,
  },
  {
    id: 'automated-messaging-birthday-campaign',
    name: 'automated-messaging-birthday-campaign',
    checked: false,
  },
  {
    id: 'CD-604-connect-enable-phone-number-references',
    name: 'CD-604-connect-enable-phone-number-references',
    checked: false,
  },
  {
    id: 'Store-on-Connect',
    name: 'Store-on-Connect',
    checked: false,
  },
  {
    id: 'CD-823-salesforce-bot',
    name: 'CD-823-salesforce-bot',
    checked: false,
  },
  {
    id: 'CD-1127-DATEV-export',
    name: 'CD-1127-DATEV-export',
    checked: false,
  },
  {
    id: 'CD-1415-new-Bank-Details-page',
    name: 'CD-1415-new-Bank-Details-page',
    checked: false,
  },
  {
    id: 'CD-1312-salesforce-bot-secure-authentication',
    name: 'CD-1312-salesforce-bot-secure-authentication',
    checked: false,
  },
  {
    id: 'CPG-63-self-onboarding-no-go-live',
    name: 'CPG-63-self-onboarding-no-go-live',
    checked: false,
  },
  {
    id: 'ff-all-partner-growth__dashboard-v1',
    name: 'Dashboard v1 / help menu',
    checked: false,
    description:
      'New single-page Dashboard, and the sidebar help block moves into the header help menu (CPG-1108, CPG-1100)',
  },
  {
    id: 'CRM-3913-custom-support-chat-enabled',
    name: 'CRM-3913-custom-support-chat-enabled',
    checked: false,
  },
  {
    id: 'CCM-1411-rebook-reminder-credits-onboarding',
    name: 'CCM-1411-rebook-reminder-credits-onboarding',
    checked: false,
  },
  {
    id: 'CCM-1044-client-export-insights-popup',
    name: 'CCM-1044-client-export-insights-popup',
    checked: false,
  },
  {
    id: 'THY-2175-online-booking-pages',
    name: 'THY-2175-online-booking-pages',
    checked: false,
  },
  {
    id: 'THY-2357-confirmation-email-log',
    name: 'THY-2357-confirmation-email-log',
    checked: false,
    description:
      'Marketing: Confirmation emails log page (booking confirmation emails and their delivery status)',
  },
  {
    id: 'pay-standalone-terminal',
    name: 'Standalone card machine charge',
    checked: false,
    description:
      'Calendar floating button to charge any amount on the card machine without a cart (TEF-4745)',
  },
  {
    id: 'CCM-1937-custom-sms-fake-door',
    name: 'CCM-1937-custom-sms-fake-door',
    checked: false,
    description:
      'Custom SMS fake door: "Send SMS" entry points that open an interest form. Nothing is ever sent. Temporary — remove with the experiment.',
  },
  {
    id: 'CCM-1984-rebook-reminder-experiment',
    name: 'CCM-1984-rebook-reminder-experiment',
    checked: false,
    description:
      'Marketing: picks the Rebook reminder free credits page (v2) over the Increase bookings page (v1) as the Marketing tab body',
  },
  {
    id: 'CCM-2145-rebook-reminder-roi-insights',
    name: 'CCM-2145-rebook-reminder-roi-insights',
    checked: false,
    description:
      'Marketing: shows the turned-on date and Earned vs. Spent on the Rebook reminder insights (v2 page)',
  },
  {
    id: 'CCM-2250-sms-credits-subscription',
    name: 'CCM-2250-sms-credits-subscription',
    checked: false,
    description:
      'Marketing: adds a Monthly / One-off choice to the Buy credits modal on the Rebook reminder pages',
  },
  {
    id: 'THY-2483-appointment-help-link',
    name: 'THY-2483-appointment-help-link',
    checked: false,
    description:
      'Edit Appointment Modal: "Need help?" link in the title row that opens the support chat',
  },
] as const;
